import React, { useEffect, useState } from "react";
import MainLayout from "../layouts/MainLayout";
import SecurityTop, {
  SecurityCarousel,
} from "../components/SecurityComponents/SecurityTop";
import securityImg from "../assets/image/securityImg.png";
import CommitmentToSecurity from "../components/SecurityComponents/CommitmentToSecurity";
import PrivacyAndGlobalCompliance from "../components/SecurityComponents/PrivacyAndGlobalCompliance";
import TrustWorthyAI from "../components/SecurityComponents/TrustWorthyAI";
import SecurityTestingAndCertification from "../components/SecurityComponents/SecurityTestingAndCertification";
import InfrastructureAndOperationalControls from "../components/SecurityComponents/InfrastructureAndOperationalControls";
import EthicalAIAndResponsibleInnovation from "../components/SecurityComponents/EthicalAIAndResponsibleInnovation";
import { fetchPageData } from "../endpoint/pageApi";

const SecurityAndTrust = ({ isMobile }) => {
  const [pageData, setPageData] = useState();
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    fetchPageData(
      "pages?filters[slug][$eq]=security-trust",
      setPageData,
      setLoader
    );
  }, []);

  return (
    <>
      <MainLayout loader={loader}>
        <div
          className="container-fluid m-0 "
          style={{ backgroundColor: " #090D24" }}
        >
          <SecurityTop
            isMobile={isMobile}
            data={pageData?.security_trust_header}
          />
          <SecurityCarousel data={pageData?.security_trust_header} />
          <CommitmentToSecurity data={pageData?.commitment_to_security} />
          <PrivacyAndGlobalCompliance
            data={pageData?.privacy_global_compliance}
          />
          <TrustWorthyAI isMobile={isMobile} data={pageData?.trustworthy_ai} />
          <SecurityTestingAndCertification
            data={pageData?.security_testing_certificate}
          />
          <InfrastructureAndOperationalControls
            data={pageData?.infra_operation_control}
          />
          <EthicalAIAndResponsibleInnovation
            data={pageData?.ethical_responsible_innovation}
          />
        </div>
      </MainLayout>
    </>
  );
};

export default SecurityAndTrust;
